module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.todo.title))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.todo.project) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "task-action"
  }, [_c('span', {
    on: {
      "click": _vm.showForm
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.deleteTodo(_vm.todo)
      }
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "content-todo-devin"
  }, [_c('div', [_c('div', [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('p', [_c('el-input', {
    attrs: {
      "placeholder": "Please input",
      "type": "text"
    },
    model: {
      value: (_vm.todo.title),
      callback: function($$v) {
        _vm.$set(_vm.todo, "title", $$v)
      },
      expression: "todo.title"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('p', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.todo.project),
      callback: function($$v) {
        _vm.$set(_vm.todo, "project", $$v)
      },
      expression: "todo.project"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.hideForm
    }
  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing && _vm.todo.done),
      expression: "!isEditing &&todo.done"
    }],
    staticClass: "todo-completed",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" Completed ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing && !_vm.todo.done),
      expression: "!isEditing && !todo.done"
    }],
    staticClass: "todo-pending",
    on: {
      "click": function($event) {
        _vm.completeTodo(_vm.todo)
      }
    }
  }, [_vm._v(" Pending ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04bbcfa8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/todo/Todo.vue
// module id = 983
// module chunks = 2